export const BAG_FEE_PART_NUMBER = "BAGFEE";
export const DELIVERY_FEE_PART_NUMBER = "DELIVERY FEE";
